"use client";

import Link from "next/link";

type MagneticButtonProps = {
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  external?: boolean;
  disabled?: boolean;
};

// transform-gpu + will-change keep the button on its own composited layer, so scaling resamples a
// high-quality texture instead of re-rasterizing the glyphs every frame (which reads as jitter).
const INTERACTION =
  "transform-gpu [will-change:transform] [backface-visibility:hidden] transition-[scale,translate,filter] duration-200 ease-out hover:-translate-y-0.5 hover:scale-[1.03] hover:brightness-110 active:scale-[0.98] active:duration-75 motion-reduce:transition-none motion-reduce:hover:translate-y-0 motion-reduce:hover:scale-100";

export function MagneticButton({
  href,
  onClick,
  children,
  className,
  external,
  disabled,
}: MagneticButtonProps) {
  const cls = `${className ?? ""} ${INTERACTION}`;

  return href ? (
    <Link
      href={href}
      className={cls}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    >
      {children}
    </Link>
  ) : (
    <button type="button" onClick={onClick} disabled={disabled} className={cls}>
      {children}
    </button>
  );
}
